module.exports = __webpack_public_path__ + "img/rubyb.f190b045.jpg";